var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq-holder"},[_c('div',{staticClass:"heading-arrow",on:{"click":_vm.openClose}},[_vm._t("heading"),_vm._v(" "),_c('IconExpand',{staticClass:"arrow",class:{ rotate: _vm.openSection }})],2),_vm._v(" "),_c('div',{staticClass:"content",class:[{ open: _vm.openSection }, 'col-11 md-12']},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }